import React, { useState } from 'react';

const HomePage = () => {
  const para = {
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    display: "-webkit-box",
  };

  // Initialize a state object to manage the open/close state of each section
  const [isOpen, setIsOpen] = useState({
    section1: false,
    section2: false,
    section3: false,
    section4: false
  });

  const handleToggle = (section) => {
    setIsOpen(prevState => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  return (
    <div className="min-h-screen bg-blue-100 font-sans">
    <div className="relative w-full h-full">
  <video 
    src='./images/5752740-uhd_3840_2160_30fps.mp4' 
    autoPlay
    loop
    muted
    playsInline
    className="w-full h-full object-cover"
  />
  <div className="absolute top-0 left-0 w-full h-full bg-black opacity-50" /> 
  <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center text-center text-white px-6 py-8">
    <div className="z-10">
      <h1 className="text-5xl font-extrabold font-mono mb-6">
       Prevomics
        Healthscience
       <br />
       Unlock Your Genetic Health Potential
  
      </h1>
      <p className="text-lg leading-relaxed">
        At Prevomics Healthscience, we are dedicated to empowering you with the most advanced genetic testing and genome sequencing solutions available. With cutting-edge technology and personalized health insights, we help you explore your genetic makeup to understand health risks, discover family history, and take control of your future well-being. Our comprehensive services deliver valuable insights tailored to your unique health profile.
      </p>
    </div>
  </div>
</div>


      {/* Main Content Section */}
      <main className="container mx-auto py-12 px-6">
        <section className="text-center p-6 mb-12">
          <h2 className="text-4xl font-semibold text-blue-600 pb-8">
            Our Comprehensive Genetic Testing Services
          </h2>

          <section className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Section 1 */}
            <div className="bg-white shadow-lg rounded-lg p-8 hover:shadow-x1 transition-shadow duration-300">
              <h3 className="text-2xl font-bold text-blue-600 mb-8">
                DNA Testing for Health Risks
              </h3>
              <img src='./images/DNA.jpg' className='rounded-lg' />
              <p
                className="text-gray-700 mt-4 leading-relaxed"
                style={isOpen.section1 ? null : para}
              >
                Understanding your genetic foundation is essential for predicting and preventing potential health challenges. Through genome sequencing, we dive deep into your genetic profile to help identify conditions such as genetic disorders, predispositions to diseases, and much more. With this information, you can make proactive choices that protect your health and well-being.
              </p>
              <button
                className=" mb-10 text-black font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 transform hover:scale-105 active:scale-95"
                onClick={() => handleToggle('section1')}
              >
                {isOpen.section1 ? 'Read Less...' : 'Read More...'}
              </button>
            </div>

            {/* Section 2 */}
            <div className="bg-white shadow-lg rounded-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-2xl font-bold text-blue-600 mb-8">
                Personalized Medicine Tailored to You
              </h3>
              <img src='./images/Personalized Medicine.jpg' className='rounded-lg' />
              <p
                className="text-gray-700 mt-4 leading-relaxed"
                style={isOpen.section2 ? null : para}
              >
                The future of healthcare lies in personalized medicine, and genetic testing plays a pivotal role. Our pharmacogenetics service tailors medication to your DNA profile, ensuring treatments are more effective, with fewer side effects. This targeted approach optimizes your medication regimen and ensures the best possible outcomes.
              </p>
              <button
                className="mb-10 text-black font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 transform hover:scale-105 active:scale-95"
                onClick={() => handleToggle('section2')}
              >
                {isOpen.section2 ? 'Read Less...' : 'Read More...'}
              </button>
            </div>

            {/* Section 3 */}
            <div className="bg-white shadow-lg rounded-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-2xl font-bold text-blue-600 mb-8">
                Genetic Counselling for Clear Understanding
              </h3>
              <img className='mb-8 rounded-lg'
              src='./images/Genetic Counselling for Clear Understanding.jpg' 
              />
              <p
                className="text-gray-700 mt-4 leading-relaxed"
                style={isOpen.section3 ? null : para}
              >
                Genetic test results can be overwhelming, but our expert genetic counsellors are here to provide you with compassionate guidance. We simplify complex information and offer personalized advice to help you navigate your genetic journey with confidence.
              </p>
              <button
                className="mb-10 text-black font-semibold py-2 px-4 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 transform hover:scale-105 active:scale-95"
                onClick={() => handleToggle('section3')}
              >
                {isOpen.section3 ? 'Read Less...' : 'Read More...'}
              </button>
            </div>

            {/* Section 4 */}
            <div className="bg-white shadow-lg rounded-lg p-8 hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-2xl font-bold text-blue-600 mb-8">
                Presymptomatic Genetic Testing
              </h3>
              <img src='./images/Presymptomatic Genetic Testing.jpg'/>
              <p
                className="text-gray-700 mt-4 leading-relaxed"
                style={isOpen.section4 ? null : para}
              >
                Concerned about your future health? Presymptomatic testing offers early insights into potential genetic conditions, empowering you to make informed decisions for a healthier future.
              </p>
              
            </div>
          </section>
        </section>
      </main>
      
      <div className="relative w-full min-h-screen bg-cover bg-center"style={{ backgroundImage: "url('./images/map.jpg')" }}
>
  {/* Overlay */}
  <div className="absolute inset-0 bg-black bg-opacity-40"></div>

  {/* Content */}
  <div className="relative flex flex-col items-center justify-center h-full text-white px-4">
   
    <h1 className="text-3xl md:text-4xl lg:text-4xl font-extrabold mb-4 mt-5 text-center drop-shadow-lg">
      Get Started on Your Genetic Health Journey Today!
    </h1>
    <p className="text-lg md:text-xl lg:text-2xl text-center leading-relaxed max-w-3xl drop-shadow-md">
      Take control of your health with advanced genetic testing that reveals
      personalized insights. Discover the power of genome sequencing, DNA
      testing, and genetic counseling to unlock your full health potential.
      Contact us today to schedule a consultation or learn more about how we
      can help you and your family.
    </p>
   
    <h1 className="text-3xl md:text-4xl lg:text-4xl font-extrabold mb-4 mt-5 text-center drop-shadow-lg">
      Testiminials
    </h1>
    <p className="text-lg md:text-xl lg:text-2xl text-center leading-relaxed max-w-3xl drop-shadow-md">
    "My personalized genetic health test through Prevomics helped me understand my risk for heart disease and made it possible to proactively adjust my lifestyle and treatments. I’m now empowered to make informed decisions about my health.
    </p>
    
    {/* Call-to-action */}
    <div className="mt-8">
      <button className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium text-lg rounded-lg shadow-md transition">
        Schedule Consultation
      </button>
    </div>
  </div>
</div>
  <div className='text-4xl text-center py-10 px-10 bg-blue-100 font-semibold text-blue-600 pb-8'>
  Top 3 Value Propositions
  <div className="relative bg-blue-100 text-gray-800 py-12 px-5 ">
  <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center max-w-7xl mx-auto">
    {/* Proposition 1 */}
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-indigo-600">Precision Health</h3>
      <p className="text-base leading-relaxed">
        Benefit from the most accurate and advanced genetic tests available.
      </p>
    </div>
    {/* Proposition 2 */}
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-indigo-600">Tailored Treatments</h3>
      <p className="text-base leading-relaxed">
        Take advantage of personalized medicine to optimize treatment efficacy and minimize risks.
      </p>
    </div>
    {/* Proposition 3 */}
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <h3 className="text-xl font-bold mb-4 text-indigo-600">Early Prevention</h3>
      <p className="text-base leading-relaxed">
        Gain actionable insights into your genetic predispositions, enabling proactive health management.
      </p>
    </div>
    </div>
</div>

  </div>
      
    </div>
    
  );
};

export default HomePage;
